// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"54924630","703":"e3ad3ded"}[chunkId] + ".chunk.js";
};